<template>
  <Head title="Productos" />
  <div class="productList">
    <div class="grid gap-4 grid-cols-1 grid-cols-2 md:grid-cols-3 lg:grid-cols-5 grid-template-rows: repeat(2, 1fr)">
      <div v-for="product in products.data" :key="product.id" class="p-4 border border-gray-300 rounded-md">
        <product-item :auth="auth" :product="product" />
      </div>
    </div>
    <!-- Reemplazar la sección de paginación -->
    <div class="mt-6 flex justify-center" v-if="products.links">
      <nav class="flex items-center gap-2">
        <Link
          v-if="products.links.prev"
          :href="getPageUrl(getPrevPage())"
          class="px-4 py-2 rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200"
          preserve-scroll
          preserve-state
        >
          Anterior
        </Link>

        <template v-for="(link, index) in getPageNumbers()" :key="index">
          <Link
            :href="getPageUrl(link)"
            class="px-4 py-2 rounded-md"
            :class="[
              currentPage === link 
                ? 'bg-blue-500 text-white' 
                : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
            ]"
            preserve-scroll
            preserve-state
          >
            {{ link }}
          </Link>
        </template>

        <Link
          v-if="products.links.next"
          :href="getPageUrl(getNextPage())"
          class="px-4 py-2 rounded-md bg-gray-100 text-gray-700 hover:bg-gray-200"
          preserve-scroll
          preserve-state
        >
          Siguiente
        </Link>
      </nav>
    </div>
  </div>
</template>
<style>
#show-content:hover + #hidden-content {
  display: block;
}
.productList{
  font-family: "Montserrat", serif !important;
  font-optical-sizing: auto;
  font-weight: 300;
  font-style: normal;
}
</style>
<script>
import ProductItem from './ProductItem.vue'
import { Head, Link } from '@inertiajs/inertia-vue3'

export default {
  components: { Head, ProductItem, Link },
  props: {
    products: Object,
    auth: Object,
    filters: Object
  },
  data() {
    return {
      quantity: 1
    }
  },
  computed: {
    currentPage() {
      return this.products.meta.current_page
    },
    lastPage() {
      return this.products.meta.last_page
    }
  },
  methods: {
    increaseQuantity() {
      this.quantity++
    },
    decreaseQuantity() {
      if (this.quantity > 1) {
        this.quantity--
      }
    },
    getPageUrl(page) {
      // Obtener los parámetros actuales de la URL
      const params = new URLSearchParams(window.location.search)
      
      // Actualizar o agregar el parámetro page
      params.set('page', page)
      
      // Retornar la ruta con todos los parámetros
      return `${window.location.pathname}?${params.toString()}`
    },
    getPrevPage() {
      return this.currentPage - 1
    },
    getNextPage() {
      return this.currentPage + 1
    },
    getPageNumbers() {
      const pages = []
      const totalPages = this.lastPage
      const currentPage = this.currentPage
      
      // Mostrar máximo 5 páginas
      let start = Math.max(1, currentPage - 2)
      let end = Math.min(totalPages, start + 4)
      
      // Ajustar el inicio si estamos cerca del final
      if (end === totalPages) {
        start = Math.max(1, end - 4)
      }
      
      for (let i = start; i <= end; i++) {
        pages.push(i)
      }
      
      return pages
    }
  },
}
</script>
